// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"c7bb8ffb","880":"fa07b9eb"}[chunkId] + ".chunk.js";
};